import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

import { MENU_STRUCTURE } from "../../constants/menu"
import { usePermissions } from "../../hooks/usePermissions"

const SidebarContent = props => {
  const { can, canAny, loading: loadingPermissions } = usePermissions();
  const ref = useRef();
  const metisMenuRef = useRef(null);
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    if (!ul) return;
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  // Inicializa o MetisMenu APÓS o DOM estar completamente pintado
  useEffect(() => {
    if (loadingPermissions) return;

    // Destruir instância anterior para evitar duplicatas
    if (metisMenuRef.current) {
      metisMenuRef.current.dispose();
      metisMenuRef.current = null;
    }

    // Aguarda o próximo frame de pintura para garantir que o DOM está completo
    const timerId = setTimeout(() => {
      metisMenuRef.current = new MetisMenu("#side-menu");
      activeMenu();
    }, 50);

    return () => clearTimeout(timerId);
  }, [loadingPermissions]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!loadingPermissions) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      activeMenu();
    }
  }, [activeMenu, loadingPermissions]);



  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const renderMenu = () => {
    if (loadingPermissions) return null;

    return MENU_STRUCTURE.map((item, index) => {
      // Controle de Permissão
      if (item.permission && !can(item.permission)) return null;
      if (item.permissions && !canAny(item.permissions)) return null;

      if (item.isHeader) {
        return <li key={index} className="menu-title">{props.t(item.label)}</li>;
      }

      if (item.subItems) {
        // Filtrar subItems acessíveis
        const visibleSubItems = item.subItems.filter(sub => {
          if (sub.permission) return can(sub.permission);
          if (sub.permissions) return canAny(sub.permissions);
          return true;
        });

        if (visibleSubItems.length === 0) return null;

        return (
          <li key={index}>
            <Link to="/#" className="has-arrow waves-effect">
              {item.icon && <i className={item.icon}></i>}
              <span>{props.t(item.label)}</span>
            </Link>
            <ul className="sub-menu">
              {visibleSubItems.map((subItem, subIndex) => (
                <li key={subIndex}>
                  <Link to={subItem.path}>{props.t(subItem.label)}</Link>
                </li>
              ))}
            </ul>
          </li>
        );
      }

      return (
        <li key={index}>
          <Link to={item.path} className="waves-effect">
            {item.icon && <i className={item.icon}></i>}
            <span>{props.t(item.label)}</span>
          </Link>
        </li>
      );
    });
  };

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {renderMenu()}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
